@if (!fullViewMode && selectedTabs === 'list') {
  <div class="row h-100">
    <p-splitter [panelSizes]="[30, 70]" [minSizes]="[20, 20]" [style]="{ height: '100%' }">
      <ng-template pTemplate>
        <section class="pt-2 pe-2 p-relative resizable col-md-12" [ngClass]="{ 'ninja-hide-element': hideSomeElementInSideMenu === true }">
          <div class="w-100 ps-0 pe-1 header-container d-flex align-items-center justify-content-between pb-2 mt-2">
            <div class="d-flex align-items-center justify-content-between w-100">
              <div (click)="back()" pTooltip="Retour">
                <i class="bi bi-arrow-left-circle-fill fs_1-5"></i>
              </div>
              <div class="d-flex align-items-center ms-3 p-fluid w-100">
                @if (boxes.length > 0 && advancedSearchDatas === null) {
                  <p-dropdown
                    id="dropdownTitle"
                    styleClass="w-100 font-sourcesans noBorder"
                    [options]="boxes"
                    placeholder="Choisir une catégorie"
                    optionValue="title"
                    optionLabel="title"
                    [filter]="true"
                    [(ngModel)]="selected"
                    (onChange)="onChange($event)">
                    <ng-template let-item pTemplate="selectedItem">
                      <div class="d-flex align-items-center">
                        <b
                          ><span style="font-size: 22px" class="font-sourcesans"
                            ><i class="me-2 dropdown_arrows"></i><i class="{{ item?.icon }} me-2 dropdown-icon"></i>{{ item?.title
                            }}<span style="font-size: 16px">&nbsp;{{ item?.count ? '(' + item?.count + ')' : '' }}</span></span
                          ></b
                        >
                      </div>
                    </ng-template>
                    <ng-template let-cat pTemplate="item">
                      <div [style.backgroundColor]="cat?.backgroundColor ? cat.backgroundColor : ''">
                        <i class="{{ cat?.icon }} me-3"></i>{{ cat.title }}
                      </div>
                    </ng-template>
                  </p-dropdown>
                }
                @if (advancedSearchDatas !== null) {
                  <i-title [text]="'Résultat' + (numberCourrier > 1 ? 's' : '') + ' de la recherche avancée ( ' + numberCourrier + ' )'"></i-title>
                }
              </div>
              <div class="d-flex align-items-end ms-3 p-fluid">
                <p-dropdown
                  appendTo="body"
                  styleClass="w-100 noBorder viewDropdown"
                  [options]="tabsArrayNewVisual"
                  [(ngModel)]="selectedTabArrayNewVisual"
                  (onChange)="onChangeNewVisual()">
                  <ng-template let-item pTemplate="selectedItem">
                    <span><i class="{{ item?.icon }} dropdown-icon" style="font-size: 22px; color: #24344b"></i></span>
                  </ng-template>
                  <ng-template let-cat pTemplate="item">
                    <div><i class="{{ cat?.icon }} me-2"></i>{{ cat?.title }}</div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
          @if (activeModeSearch !== 'serviceSearch' && advancedSearchDatas === null) {
            <div class="d-flex align-items-center justify-content-between tac-search-field w-100 mb-4">
              <div class="divForAbsolute w-100">
                <span class="p-input-icon-left w-100">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    class="form-control input--search-field ps-5 advSearch__field"
                    [placeholder]="'searchMail' | translate"
                    [(ngModel)]="searchString"
                    (keydown.enter)="searchMail()"
                    (focus)="onFocusInput = true" />
                </span>
                @if (onFocusInput) {
                  <i-button
                    #searchButton
                    id="dropdownButtonToggleHomeCourrierChild"
                    icon="dropdown_arrows_white_margin_left"
                    iconPosition="right"
                    styleClass="gray tac-nowrap advSearch__btn tac-dropdown-search dropdownPosition marginForAbsolute"
                    [text]="dropdownLabel"
                    (click)="showOverlayDropdown = !showOverlayDropdown">
                  </i-button>
                }
                <div class="dropdown-menu dropdownPosition" [ngClass]="{ 'd-block': showOverlayDropdown }">
                  @if (dropdownValue !== 'Recherche basique') {
                    <a class="dropdown-item" (click)="onClickDropdownInput('Recherche basique')">
                      <div class="d-flex align-items-center">
                        <span>{{ 'basicSearch' | translate }}</span>
                      </div>
                    </a>
                  }
                  @if (dropdownValue !== 'Services') {
                    <a class="dropdown-item" (click)="onClickDropdownInput('Services')">
                      <div class="d-flex align-items-center">
                        <span>{{ 'service-s' | translate }}</span>
                      </div>
                    </a>
                  }
                  @if (dropdownValue !== 'Objet') {
                    <a class="dropdown-item" (click)="onClickDropdownInput('Objet')">
                      <div class="d-flex align-items-center">
                        <span>{{ 'object' | translate }}</span>
                      </div>
                    </a>
                  }
                  @if (dropdownValue !== 'Id') {
                    <a class="dropdown-item" (click)="onClickDropdownInput('Id')">
                      <div class="d-flex align-items-center">
                        <span>{{ 'id' | translate }}</span>
                      </div>
                    </a>
                  }
                </div>
                @if (onFocusInput) {
                  <i-button
                    icon="bi bi-search"
                    styleClass="blue ms-2 tac-nowrap advSearch__btn marginForAbsolute"
                    pTooltip="Rechercher"
                    (click)="onSearchButtonClick()">
                  </i-button>
                }
              </div>
            </div>
          }
          @if (activeModeSearch === 'serviceSearch' && advancedSearchDatas === null) {
            <div class="divForAbsolute w-100 mb-4">
              <span class="p-input-icon-left w-100">
                <i class="pi pi-search"></i>
                <input
                  type="text"
                  [pTooltip]="inputDisplayOnServiceSearchTooltip"
                  [readonly]="true"
                  (click)="openModalTreeServicesSelection = true"
                  class="form-control input--search-field ps-5 advSearch__field cursor--pointer"
                  [(ngModel)]="inputDisplayOnServiceSearch" />
              </span>
              <i-button
                text="Réinitialiser"
                styleClass="red ms-2 tac-nowrap advSearch__btn marginForAbsolute"
                [pTooltip]="'reset' | translate"
                (click)="reset()">
              </i-button>
            </div>
          }
          <!-- input pour la recherche avancée -->
          @if (advancedSearchDatas !== null && !advancedSearchDatas.Id) {
            <div class="divForAbsolute w-100 mb-4">
              <span class="p-input-icon-left w-100">
                <i class="pi pi-search"></i>
                <input
                  [placeholder]="'searchMail' | translate"
                  type="text"
                  class="form-control input--search-field ps-5 advSearch__field"
                  [(ngModel)]="inputDisplayOnAdvancedSearch"
                  (keydown.enter)="searchMailAdvancedSearch()" />
              </span>
              <i-button
                icon="bi bi-search"
                styleClass="blue ms-2 tac-nowrap advSearch__btn marginForAbsolute"
                [pTooltip]="'search' | translate"
                (click)="searchMailAdvancedSearch()">
              </i-button>
            </div>
          }
          @if (advancedSearchDatas && advancedSearchArray.length > 0) {
            <div class="roundDiv row ms-1 me-1 mb-1 darkblue-bg">
              <div class="col-12 noPaddingRight">
                <div class="d-flex justify-content-left align-items-center">
                  <svg
                    class="me-3"
                    width="16px"
                    height="16px"
                    viewBox="0 0 14 14"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="iCourrier" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Medium-Copy-17" transform="translate(-115, -153)" fill="#FFFFFF" fill-rule="nonzero">
                        <g id="Shape" transform="translate(115, 153)">
                          <path
                            d="M5.74878538,7.58333333 C5.49779186,8.42668426 4.71654768,9.04166667 3.79166667,9.04166667 C2.86678565,9.04166667 2.08554146,8.42668426 1.83454795,7.58333333 L0.583738537,7.58333333 C0.261348645,7.58333333 0,7.3244122 0,7 C0,6.6778339 0.261023711,6.41666667 0.583738537,6.41666667 L1.83454795,6.41666667 C2.08554146,5.57331574 2.86678565,4.95833333 3.79166667,4.95833333 C4.71654768,4.95833333 5.49779186,5.57331574 5.74878538,6.41666667 L13.4162615,6.41666667 C13.7386514,6.41666667 14,6.6755878 14,7 C14,7.3221661 13.7389763,7.58333333 13.4162615,7.58333333 L5.74878538,7.58333333 Z M8.25121462,11.375 C8.50220814,10.5316491 9.28345233,9.91666667 10.2083333,9.91666667 C11.1332143,9.91666667 11.9144585,10.5316491 12.165452,11.375 L13.4162615,11.375 C13.7386514,11.375 14,11.6339211 14,11.9583333 C14,12.2804994 13.7389763,12.5416667 13.4162615,12.5416667 L12.165452,12.5416667 C11.9144585,13.3850176 11.1332143,14 10.2083333,14 C9.28345233,14 8.50220814,13.3850176 8.25121462,12.5416667 L0.583738537,12.5416667 C0.261348645,12.5416667 0,12.2827455 0,11.9583333 C0,11.6361672 0.261023711,11.375 0.583738537,11.375 L8.25121462,11.375 Z M8.25121462,1.45833333 C8.50220814,0.61498239 9.28345233,0 10.2083333,0 C11.1332143,0 11.9144585,0.61498239 12.165452,1.45833333 L13.4162615,1.45833333 C13.7386514,1.45833333 14,1.71725448 14,2.04166667 C14,2.36383277 13.7389763,2.625 13.4162615,2.625 L12.165452,2.625 C11.9144585,3.46835093 11.1332143,4.08333333 10.2083333,4.08333333 C9.28345233,4.08333333 8.50220814,3.46835093 8.25121462,2.625 L0.583738537,2.625 C0.261348645,2.625 0,2.36607886 0,2.04166667 C0,1.71950056 0.261023711,1.45833333 0.583738537,1.45833333 L8.25121462,1.45833333 Z M10.2083333,2.91666667 C10.6915825,2.91666667 11.0833333,2.52491582 11.0833333,2.04166667 C11.0833333,1.55841751 10.6915825,1.16666667 10.2083333,1.16666667 C9.72508419,1.16666667 9.33333333,1.55841751 9.33333333,2.04166667 C9.33333333,2.52491582 9.72508419,2.91666667 10.2083333,2.91666667 Z M10.2083333,12.8333333 C10.6915825,12.8333333 11.0833333,12.4415825 11.0833333,11.9583333 C11.0833333,11.4750842 10.6915825,11.0833333 10.2083333,11.0833333 C9.72508419,11.0833333 9.33333333,11.4750842 9.33333333,11.9583333 C9.33333333,12.4415825 9.72508419,12.8333333 10.2083333,12.8333333 Z M3.79166667,6.125 C3.30841752,6.125 2.91666667,6.51675086 2.91666667,7 C2.91666667,7.48324914 3.30841752,7.875 3.79166667,7.875 C4.27491581,7.875 4.66666667,7.48324914 4.66666667,7 C4.66666667,6.51675086 4.27491581,6.125 3.79166667,6.125 Z"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <div class="w-100 pt-3 pb-3 ps-3 pe-3 white-bg borderRadiusOnRightSide">
                    <app-display-filters
                      [filters]="advancedSearchArray"
                      [contacts]="contacts"
                      [contactsiAdmin]="contactsiAdmin"
                      [naturesLV]="natureListLV"
                      [sourcesLV]="sourceListLV"
                      (resetAdvancedSearch)="reset()"></app-display-filters>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (!isLoading && mails.length > 0) {
            <p-scrollPanel
              class="w-100"
              [ngClass]="{
                superListContainerAdvancedSearch: advancedSearchDatas && advancedSearchArray.length > 0,
                superListContainer: !advancedSearchDatas,
              }"
              #superListContainer>
              <div class="d-flex align-items-center justify-content-end">
                @if (multipleItemsSelected.length > 0 && currentTag?.toLowerCase() === 'avalider') {
                  <button (click)="validate(multipleItemsSelected)" class="blue btn btn-small me-3 mb-3">Valider</button>
                }
                @if (multipleItemsSelected.length > 0 && currentTag?.toLowerCase() === 'adistribuer') {
                  <button (click)="distribute(multipleItemsSelected)" class="blue btn btn-small me-3 mb-3">Marquer comme distribué</button>
                }
                @if (multipleItemsSelected.length > 0 && currentTag?.toLowerCase() !== 'lus') {
                  <button (click)="markAsReadedMultiple(multipleItemsSelected)" class="blue btn btn-small me-3 mb-3">Marquer comme lu</button>
                }
              </div>
              <app-super-list-new-visual
                #idSuperListDashboard
                [items]="mails"
                (selectedValue)="receiveItem($event)"
                activeItem="mailActive"
                [boolMultiSelect]="enableMultiselect"
                (multiSelectValue)="selectMultiple($event)"
                [resetSelectedItems]="resetSelectedItems"
                keyLockTooltip="Ce courrier est confidentiel et son accès est restreint aux seules personnes ayant les droits"
                [ngClass]="{ 'd-none': searchLoaded === false }">
              </app-super-list-new-visual>
              <!-- Will display only the "display more mails" at the end of list of mails -->
              @if (mails.length < numberCourrier) {
                <app-super-list-new-visual
                  [items]="nextPageMail"
                  (selectedValue)="onReachEndDetermineWitchMethodToCall()"
                  activeItem="mailActive"
                  [boolMultiSelect]="false"
                  [isAdvancedSearch]="advancedSearchDatas && advancedSearchArray.length > 0"
                  [ngClass]="{ 'd-none': searchLoaded === false }">
                </app-super-list-new-visual>
              }
              @if (searchLoaded === false && !flagStoppingTheRequest) {
                <div class="d-flex flex-column align-items-center justify-content-center mt-4">
                  <p-progressSpinner stroke="2"></p-progressSpinner>
                  <p class="d-block">{{ 'homeCourrierChild.weSearch' | translate }}</p>
                </div>
              }
            </p-scrollPanel>
          }
          @if (!isLoading && mails.length === 0) {
            <div class="alert alert-danger d-flex flex-column align-items-center justify-content-center mt-4">
              {{ 'homeCourrierChild.noMailWasFound' | translate }}
            </div>
          }
          @if (flagStoppingTheRequest) {
            <div class="alert alert-danger d-flex flex-column align-items-center justify-content-center mt-4">
              <p class="d-block">{{ 'homeCourrierChild.searchErrorWithId' | translate: { id: flagStoppingTheRequestId } }}</p>
            </div>
          }
        </section>
      </ng-template>
      <ng-template pTemplate>
        @if (mails.length > 0 && !welcomeMode) {
          <section class="container-right" [ngClass]="{ 'col-md-10': reduceAll === true, 'col-md-12': reduceAll === false }">
            <router-outlet></router-outlet>
          </section>
        }
        @if (mails.length === 0 && !welcomeMode) {
          <section
            class="h-100 d-flex justify-content-center align-items-center"
            [ngClass]="{ 'col-md-10': reduceAll === true, 'col-md-12': reduceAll === false }">
            <img src="./assets/img/decoration/no-result.svg" width="700" height="700" alt="No result image" />
          </section>
        }
        @if (welcomeMode) {
          <section
            class="h-100 d-flex flex-column justify-content-center align-items-center"
            [ngClass]="{ 'col-md-10': reduceAll === true, 'col-md-12': reduceAll === false }">
            <img src="./assets/img/listAnimation.gif" width="200" height="200" alt="" />
            <h3>{{ 'homeCourrierChild.selectMail' | translate }}</h3>
            <p>{{ 'homeCourrierChild.selectMailMore' | translate }}</p>
          </section>
        }
      </ng-template>
    </p-splitter>
  </div>
}
@if (selectedTabs === 'table') {
  <div class="row pt-2">
    <div class="col-md-12 super-compos-sectionseparator-horizontal">
      <div class="w-100 ps-0 pe-0 header-container d-flex align-items-center justify-content-between pb-2">
        <div class="d-flex align-items-center justify-content-center mb-2">
          <p-dropdown styleClass="w-100" [options]="tabsArrayNewVisual" [(ngModel)]="selectedTabArrayNewVisual" (onChange)="onChangeNewVisual()">
            <ng-template let-item pTemplate="selectedItem">
              <span><i class="{{ item?.icon }} me-3 dropdown-icon"></i></span>
            </ng-template>
            <ng-template let-cat pTemplate="item">
              <div><i class="{{ cat?.icon }} me-3"></i>{{ cat?.title }}</div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="d-flex align-items-center">
          <div class="p-fluid me-3">
            @if (boxes.length > 0 && advancedSearchDatas === null) {
              <p-dropdown
                styleClass="w-100"
                [options]="boxes | sort: 'title' : 'ASC'"
                optionValue="title"
                optionLabel="title"
                [filter]="true"
                [(ngModel)]="selected"
                (onChange)="onChange($event)">
                <ng-template let-item pTemplate="selectedItem">
                  <span><i class="{{ item?.icon }} me-3 dropdown-icon"></i>{{ item?.title }} {{ item?.count ? '(' + item?.count + ')' : '' }}</span>
                </ng-template>
                <ng-template let-cat pTemplate="item">
                  <div><i class="{{ cat?.icon }} me-3"></i>{{ cat.title }}</div>
                </ng-template>
              </p-dropdown>
            }
            @if (advancedSearchDatas !== null) {
              <h1 class="custom-h1-title border-0 m-0">{{ 'homeCourrierChild.resultSearch' | translate }}</h1>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-3">
      @if (activeModeSearch !== 'serviceSearch' && advancedSearchDatas === null) {
        <div class="d-flex align-items-center justify-content-between tac-search-field w-100 mb-4">
          <div class="divForAbsolute w-100">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                type="text"
                class="form-control input--search-field ps-5 advSearch__field"
                [placeholder]="'searchMail' | translate"
                [(ngModel)]="searchString"
                (keydown.enter)="searchMail()"
                (focus)="onFocusInput = true" />
            </span>
            @if (onFocusInput) {
              <i-button
                #searchButton
                [text]="dropdownLabel"
                icon="dropdown_arrows_white_margin_left"
                iconPosition="right"
                styleClass="gray tac-nowrap advSearch__btn tac-dropdown-search dropdownPosition marginForAbsolute"
                (click)="showOverlayDropdown = !showOverlayDropdown">
              </i-button>
            }
            <div class="dropdown-menu dropdownPosition" [ngClass]="{ 'd-block': showOverlayDropdown }" data-bs-auto-close="outside">
              @if (dropdownValue !== 'Recherche basique') {
                <a class="dropdown-item" data-bs-auto-close="outside" (click)="onClickDropdownInput('Recherche basique')">
                  <div class="d-flex align-items-center">
                    <span>{{ 'basicSearch' | translate }}</span>
                  </div>
                </a>
              }
              @if (dropdownValue !== 'Services') {
                <a class="dropdown-item" data-bs-auto-close="outside" (click)="onClickDropdownInput('Services')">
                  <div class="d-flex align-items-center">
                    <span>{{ 'service-s' | translate }}</span>
                  </div>
                </a>
              }
              @if (dropdownValue !== 'Objet') {
                <a class="dropdown-item" data-bs-auto-close="outside" (click)="onClickDropdownInput('Objet')">
                  <div class="d-flex align-items-center">
                    <span>{{ 'object' | translate }}</span>
                  </div>
                </a>
              }
              @if (dropdownValue !== 'Id') {
                <a class="dropdown-item" data-bs-auto-close="outside" (click)="onClickDropdownInput('Id')">
                  <div class="d-flex align-items-center">
                    <span>{{ 'id' | translate }}</span>
                  </div>
                </a>
              }
            </div>
            @if (onFocusInput) {
              <i-button
                icon="bi bi-search"
                styleClass="blue ms-2 tac-nowrap advSearch__btn marginForAbsolute"
                [pTooltip]="'search' | translate"
                (click)="onSearchButtonClick()">
              </i-button>
            }
          </div>
        </div>
      }
      @if (activeModeSearch === 'serviceSearch' && advancedSearchDatas === null) {
        <div class="divForAbsolute w-100 mb-4">
          <span class="p-input-icon-left w-100">
            <i class="pi pi-search"></i>
            <input
              [pTooltip]="inputDisplayOnServiceSearchTooltip"
              type="text"
              [readonly]="true"
              class="form-control input--search-field ps-5 advSearch__field cursor--pointer"
              (click)="openModalTreeServicesSelection = true"
              [(ngModel)]="inputDisplayOnServiceSearch" />
          </span>
          <i-button
            text="Réinitialiser"
            styleClass="red ms-2 tac-nowrap advSearch__btn marginForAbsolute"
            [pTooltip]="'reset' | translate"
            (click)="reset()">
          </i-button>
        </div>
      }
      @if (advancedSearchDatas !== null && !advancedSearchDatas.Id) {
        <div class="d-flex align-items-center mb-4">
          <input
            type="text"
            class="form-control input--search-field ps-5"
            [placeholder]="'searchMail' | translate"
            [(ngModel)]="inputDisplayOnAdvancedSearch"
            (keydown.enter)="searchMailAdvancedSearch()" />
          <div class="d-flex">
            <i-button
              pTooltip="Rechercher un courrier par son objet, son ID, etc."
              styleClass="blue ms-3 me-2"
              size="small"
              [text]="'search' | translate"
              (click)="searchMailAdvancedSearch()">
            </i-button>
            <i-button [text]="'reset' | translate" pTooltip="Réinitialiser" styleClass="red" size="small" (click)="resetAdvancedSearch()"> </i-button>
          </div>
        </div>
      }
      @if (!flagStoppingTheRequest) {
        <div class="text-center">
          @if (numberCourrier) {
            <p class="alert alert-info">{{ 'homeCourrierChild.ThereAreMails' | translate: { numberCourrier: numberCourrier } }}</p>
          }
          @if (mails.length === 0) {
            <p class="alert alert-info">{{ 'homeCourrierChild.ThereAreNoMails' | translate }}</p>
          }
        </div>
      }
    </div>
    @if (searchLoaded && !flagStoppingTheRequest) {
      <div class="col-md-12">
        @if (mails.length > 0) {
          <div>
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <p-dropdown
                  [ngClass]="{ hiddenVisibility: advancedSearchDatas !== null && advancedSearchDatas.Id }"
                  [(ngModel)]="sizeChoice"
                  [options]="sizeOfPages"
                  (onChange)="changeSize()"
                  inputStyleClass="w-100"
                  styleClass="dropdown-inforius">
                </p-dropdown>
              </div>
              <div>
                <p-dropdown
                  [ngClass]="{ hiddenVisibility: advancedSearchDatas === null || !advancedSearchDatas?.ExportNatureCustomDatas }"
                  [(ngModel)]="chosenNatureForAdvancedSearchComplDatas"
                  [options]="natureListLV"
                  (onChange)="getComplDatasForNatureChosen($event)"
                  inputStyleClass="w-100"
                  styleClass="dropdown-inforius"
                  showClear="true"
                  [filter]="true"
                  [placeholder]="'admin.selectANatureForComplementaryDatas' | translate"
                  (onClear)="getComplDatasForNatureChosen(null)">
                </p-dropdown>
              </div>
              @if (advancedSearchDatas === null || (advancedSearchDatas !== null && !advancedSearchDatas.Id)) {
                <div>
                  @if (+mailsObject?.pageNumber !== 1) {
                    <i class="bi bi-arrow-left-circle-fill me-2 cursor--pointer" (click)="paginate(+mailsObject?.pageNumber - 1)"></i>
                  }
                  <small class="me-3">Page {{ mailsObject?.pageNumber }} sur {{ totalPages }}</small>
                  @if (mailsObject?.pageNumber !== totalPages) {
                    <i class="bi bi-arrow-right-circle-fill cursor--pointer" (click)="paginate(+mailsObject?.pageNumber + 1)"></i>
                  }
                </div>
              }
              @if (advancedSearchDatas !== null && advancedSearchDatas.Id) {
                <div>
                  <small class="me-3">Page 1 sur 1</small>
                </div>
              }
            </div>
            @if (mails && mails.length > 0 && displaySuperTableTableView) {
              <i-table
                (onClickRow)="showDialog($event)"
                (onClickDelete)="deleteCourrier($event)"
                [height]="'calc(100vh - 300px)'"
                [paginator]="true"
                class="super-table"
                [columns]="columnTable"
                [items]="mails"
                [id]="idTable"
                [multiselect]="true"
                [search]="true"
                [menu]="itemsMenu"
                #superTableTableView
                (menuItemsRowClick)="receive_menu($event)"
                [forselection]="forselection"
                [enableConfirmColumn]="true"
                (stateColumn)="saveColumn($event)">
              </i-table>
            }
          </div>
        }
      </div>
    }
    @if (!searchLoaded && flagStoppingTheRequest) {
      <div class="col-md-12 text-center">
        <p class="alert alert-danger">{{ 'homeCourrierChild.searchErrorWithId' | translate: { id: flagStoppingTheRequestId } }}</p>
      </div>
    }
  </div>
}

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="openModalTreeServicesSelection"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  [style]="{ width: '80vw' }">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'pleaseSelectOneOrMultipleServices' | translate }}</h5>
    </div>
  </p-header>
  <section class="mb-3 maxHeight60vh">
    @if (serviceParent?.length > 0) {
      <p-tree
        #pTree
        styleClass="pTreeServicesModal w-100"
        [emptyMessage]="'noResultFound' | translate"
        [value]="serviceParent | sort: 'label'"
        [filter]="true"
        [propagateSelectionUp]="false"
        [propagateSelectionDown]="true"
        selectionMode="checkbox"
        [(selection)]="selectedOption">
      </p-tree>
    }
    @if (!serviceParent || serviceParent.length === 0) {
      <div class="alert alert-info">{{ 'youDoNotHaveAnyService' | translate }}</div>
    }
  </section>
  <i-button styleClass="bottomButton red mb-3" (click)="resetServiceModal()" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" (click)="sendServicesToSearch()" [text]="'validate' | translate"></i-button>
</p-dialog>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white">{{ 'loading' | translate }}</p>
</ngx-spinner>

<p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal" header="Confirmation" icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" class="pButtonRed" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
